import { useEffect } from 'react';
import PropTypes from 'prop-types';

const CaptchaValidation = ({ onSuccess, action = 'submit' }) => {
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

  useEffect(() => {
    const runRecaptcha = async () => {
      if (!window.grecaptcha) return;

      await window.grecaptcha.ready(() => {
        window.grecaptcha.execute(siteKey, { action }).then((token) => {
          if (token) {
            onSuccess(token); // odošli token rodičovi alebo backendu
          }
        });
      });
    };

    runRecaptcha();
  }, [siteKey, action, onSuccess]);

  return null; // Žiadny vizuálny komponent, v3 beží na pozadí
};

CaptchaValidation.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  action: PropTypes.string,
};

export default CaptchaValidation;
